
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { submitContact, clearContactState } from "../../slice/contactSlice";
import contactus from '../../assets/images/contactus.jpeg'
const Contact = () => {
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((state) => state.contact);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});


  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };


  const validate = () => {
    const newErrors = {};
    if (!formData.name || formData.name.length < 3)
      newErrors.name = "Name must be at least 3 characters.";
    if (!formData.mobile || !/^\d{10}$/.test(formData.mobile))
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    if (!formData.subject) newErrors.subject = "Subject is required.";
    if (!formData.message) newErrors.message = "Message is required.";
    return newErrors;
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
     
      dispatch(submitContact(formData));
    }
  };

  
  useEffect(() => {
    if (success || error) {
      const timer = setTimeout(() => dispatch(clearContactState()), 3000);
      return () => clearTimeout(timer);
    }
  }, [success, error, dispatch]);

  return (
    <div className="flex flex-col items-center justify-center px-4 py-10 bg-[#f0f4f8]">
      <h1 className="text-3xl sm:text-4xl font-bold text-[#0464a4] text-center mb-8">
        Contact Us
      </h1>

      <div className="max-w-4xl w-full flex flex-col md:flex-row bg-white shadow-xl rounded-2xl overflow-hidden">
       
        <div className="w-full md:w-1/2 flex items-center justify-center bg-gray-50 p-4 md:p-0">
          <img
            src={contactus}
            alt="Contact"
            className="w-full max-w-md md:max-w-full h-64 md:h-full object-cover object-center rounded-xl md:rounded-none"
          />
        </div>

        {/* Right side form */}
        <div className="w-full md:w-1/2 p-8 md:p-12">
          {success && (
            <p className="text-green-600 mb-4">Message sent successfully!</p>
          )}
          {error && <p className="text-red-600 mb-4">{error}</p>}

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Name */}
            <div>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-4 border border-[#0464a4] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#e58505]"
              />
              {errors.name && (
                <p className="text-red-500 text-sm mt-1">{errors.name}</p>
              )}
            </div>

            {/* Mobile */}
            <div>
              <input
                type="tel"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleChange}
                className="w-full p-4 border border-[#0464a4] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#e58505]"
              />
              {errors.mobile && (
                <p className="text-red-500 text-sm mt-1">{errors.mobile}</p>
              )}
            </div>

            {/* Subject */}
            <div>
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                className="w-full p-4 border border-[#0464a4] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#e58505]"
              />
              {errors.subject && (
                <p className="text-red-500 text-sm mt-1">{errors.subject}</p>
              )}
            </div>

            {/* Message */}
            <div>
              <textarea
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                className="w-full p-4 border border-[#0464a4] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#e58505] h-32 resize-none"
              />
              {errors.message && (
                <p className="text-red-500 text-sm mt-1">{errors.message}</p>
              )}
            </div>

            {/* Submit Button */}
            <div className="text-center">
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#e58505] hover:bg-[#cf6e02] text-white font-semibold py-3 rounded-full transition-colors"
              >
                {loading ? "Sending..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
